import React from "react";
import { Card, RiskStatusIcon, SearchChip } from "@sscs/ui";
import { useGetReportMappingsQuery } from "Services";
import useSearch from "../../../../hooks/useSearch";
import { Insight } from "../../../../types";
import styles from "./policyViolations.module.scss";

type PolicyViolationsProps = {
  violations: string[];
  evaluations: Insight["risk_assessment_evaluation"];
};

const PolicyViolations = ({
  violations,
  evaluations,
}: PolicyViolationsProps): React.JSX.Element => {
  const { handleChipClick } = useSearch();
  const { data: reportMappings } = useGetReportMappingsQuery();

  const handleIssueClick = (issueId: string) => {
    handleChipClick("policy_id", {
      operation: "is_any",
      values: [issueId],
    });
  };

  return (
    <Card.Card>
      <Card.Title>Policy violations</Card.Title>
      <Card.Content className={styles.violations}>
        {violations.map((policyId) => {
          const risk = evaluations.find((evaluation) =>
            evaluation.violations.includes(policyId),
          );

          return (
            <div key={policyId} className={styles.issue}>
              <SearchChip
                label={policyId}
                onClick={() => handleIssueClick(policyId)}
              />
              <div>
                <div
                  data-testid="policy-description"
                  className={styles["policy-description"]}
                >
                  {reportMappings?.descriptions[policyId]}
                </div>
                {risk && (
                  <div className={styles.risk}>
                    Causes risk:&nbsp;
                    <RiskStatusIcon
                      status={risk.status}
                      disabled={false}
                      size="inherit"
                    />
                    &nbsp;{risk.label}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </Card.Content>
    </Card.Card>
  );
};

export default PolicyViolations;
